import _ from 'lodash';
import React from 'react';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { ThemeProvider } from 'styled-components';
import theme from '../../../../assets/stylesheets/_settings.global.scss';
import Loading from '../../../shared/loading';
import useAdvertisingsStore from './advertisings-components/state-hook';
import { Container, ContentContainer } from '../shared/styles';
import { useGetAdvertisings } from '../../../services/lwadmin/advertising/advertising-service';
import Advertising from './advertisings-components/advertising';
import Actions from './advertisings-components/actions';
import Header from './advertisings-components/header';

export default function Advertisings() {
  const set = useAdvertisingsStore(state => state.set);
  const advertisings = useAdvertisingsStore(state => state.advertisings);
  const [{ loading }, get] = useGetAdvertisings();
  const loadingRef = React.useRef();

  useChangeAwareEffect(({ isMount }) => {
    isMount && get().then(({ data }) => {
      set(state => {
        state.advertisings = _.get(data, 'advertisings', []);
      });
    });
  }, {});

  React.useEffect(() => (loadingRef.current.toggle(loading)), [loading]);

  return (
    <ThemeProvider theme={theme}>
      <Container>
        <ContentContainer>
          <h1>Advertisings</h1>
          <Header />
          <Loading ref={loadingRef}>
            {advertisings.map(ad => <Advertising key={ad.id} advertising={ad} />)}
          </Loading>
        </ContentContainer>
        <Actions />
      </Container>
    </ThemeProvider>
  );
}
